import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "activity-nav-action-widget" }
const _hoisted_2 = { class: "activity-nav-dialog" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "activity-nav-tip" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "activity-nav-tip__title" }, "勾选说明"),
  /*#__PURE__*/_createElementVNode("div", { class: "activity-nav-tip__desc" }, "勾选侧边导航即可，系统自动使用对应的默认横版导航")
], -1)
const _hoisted_4 = { class: "activity-nav-tree" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "activity-nav-tree__title" }, "选择侧边导航（可多选）", -1)
const _hoisted_6 = { class: "activity-nav-tree__panel" }
const _hoisted_7 = { class: "activity-nav-tree-node" }
const _hoisted_8 = {
  key: 1,
  class: "activity-nav-tree__empty"
}

import { ref } from 'vue';
import { OioButton, OioModal, OioSpin } from '@kunlun/vue-ui-antd';

interface CmNavRecord {
  id: string;
  code: string;
  name: string;
  navType: string | Record<string, any>;
  parentId?: string;
  parentCode?: string;
}

interface ActivityNavRelRecord {
  id?: number;
  sideNavId?: string;
  sideNavCode?: string;
  sideNavName?: string;
  sideNavSort?: number;
  horizontalNavId?: string;
  horizontalNavCode?: string;
  horizontalNavName?: string;
  horizontalNavSort?: number;
}

interface TreeNode {
  key: string;
  title: string;
  code: string;
  raw: CmNavRecord;
}

interface Props {
  label: string;
  disabled: boolean;
  queryNavTree: () => Promise<CmNavRecord[]>;
  getCurrentRows: () => ActivityNavRelRecord[];
  setRootTableData: (rows: ActivityNavRelRecord[]) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddActivityNav',
  props: {
    label: null,
    disabled: { type: Boolean },
    queryNavTree: null,
    getCurrentRows: null,
    setRootTableData: null
  },
  setup(__props: any) {

const props = __props as {
  label: string;
  disabled: boolean;
  queryNavTree: () => Promise<CmNavRecord[]>;
  getCurrentRows: () => ActivityNavRelRecord[];
  setRootTableData: (rows: ActivityNavRelRecord[]) => void;
}



const visible = ref(false);
const loading = ref(false);
const confirmLoading = ref(false);
const checkedKeys = ref<string[]>([]);
const treeData = ref<TreeNode[]>([]);
const navMap = ref<Record<string, CmNavRecord>>({});

const handleCheck = (keys: string[] | { checked: string[] }) => {
  checkedKeys.value = Array.isArray(keys) ? keys : keys.checked;
};

const closeModal = () => {
  visible.value = false;
};

const getNavTypeCode = (navType: CmNavRecord['navType']) => {
  if (!navType) {
    return '';
  }
  if (typeof navType === 'string') {
    return navType;
  }
  return navType.value || navType.name || navType.code || '';
};

const isSideNav = (item: CmNavRecord) => {
  const navTypeCode = getNavTypeCode(item.navType);
  return navTypeCode === 'SIDE' || item.code?.startsWith('CB');
};

const buildTreeData = (records: CmNavRecord[]) => {
  return records
    .filter((item) => isSideNav(item))
    .sort((a, b) => a.code.localeCompare(b.code))
    .map<TreeNode>((item) => ({
      key: item.code,
      title: item.name,
      code: item.code,
      raw: item
    }));
};

const openModal = async () => {
  visible.value = true;
  checkedKeys.value = [];
  loading.value = true;
  try {
    const records = await props.queryNavTree();
    navMap.value = records.reduce<Record<string, CmNavRecord>>((acc, item) => {
      acc[item.code] = item;
      return acc;
    }, {});
    treeData.value = buildTreeData(records);
  } finally {
    loading.value = false;
  }
};

const submitSelection = async () => {
  confirmLoading.value = true;
  try {
    const selectedSideCodes = checkedKeys.value.filter((key) => {
      return treeData.value.some((node) => node.key === key);
    });
    if (!selectedSideCodes.length) {
      closeModal();
      return;
    }

    const currentRows = props.getCurrentRows() || [];
    const existingCodeSet = new Set(currentRows.map((item) => item.sideNavCode).filter(Boolean));
    const rows: ActivityNavRelRecord[] = [];

    selectedSideCodes.forEach((code) => {
      if (existingCodeSet.has(code)) {
        return;
      }
      const sideNav = navMap.value[code];
      if (!sideNav) {
        return;
      }
      const defaultHorizontal = Object.values(navMap.value).find(
        (item) => item.parentCode === code
      );
      rows.push({
        sideNavId: sideNav.id,
        sideNavCode: sideNav.code,
        sideNavName: sideNav.name,
        horizontalNavId: defaultHorizontal?.id,
        horizontalNavCode: defaultHorizontal?.code,
        horizontalNavName: defaultHorizontal?.name
      });
    });

    if (rows.length) {
      props.setRootTableData(rows);
    }
    closeModal();
  } finally {
    confirmLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_tree = _resolveComponent("a-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(OioButton), {
      type: "primary",
      size: "small",
      disabled: __props.disabled,
      onClick: openModal
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.label), 1)
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_unref(OioModal), {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      title: "添加导航栏",
      width: 760,
      maskClosable: false,
      onCancel: closeModal
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), { onClick: closeModal }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(OioButton), {
          type: "primary",
          loading: confirmLoading.value,
          onClick: submitSelection
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定添加")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_unref(OioSpin), { loading: loading.value }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (treeData.value.length)
                    ? (_openBlock(), _createBlock(_component_a_tree, {
                        key: 0,
                        checkable: "",
                        "block-node": "",
                        "default-expand-all": "",
                        "tree-data": treeData.value,
                        checkedKeys: checkedKeys.value,
                        onCheck: handleCheck
                      }, {
                        title: _withCtx(({ title, code }) => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", null, _toDisplayString(title) + "（" + _toDisplayString(code) + "）", 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["tree-data", "checkedKeys"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, "暂无导航数据"))
                ])
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})